import { CircularProgress, Container } from "@mui/material";

export const BaseLoader = () => {
  return (
    <Container sx={{ textAlign: "center", mt: 5, height: "calc(40vh - 64px)" }}>
      <CircularProgress />
    </Container>
  );
};
